<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="orderId" >
        <span slot="label" >
          <a-tooltip>
            订单ID<template slot="title">订单ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderId"  :placeholder="$t('请输入')+'订单ID'" />
      </a-form-model-item>
      <a-form-model-item prop="orderItemId" >
        <span slot="label" >
          <a-tooltip>
            订单明细ID<template slot="title">订单明细ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderItemId"  :placeholder="$t('请输入')+'订单明细ID'" />
      </a-form-model-item>
      <a-form-model-item prop="goodsId" >
        <span slot="label" >
          <a-tooltip>
            商品ID<template slot="title">商品ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsId"  :placeholder="$t('请输入')+'商品ID'" />
      </a-form-model-item>
      <a-form-model-item prop="skuId" >
        <span slot="label" >
          <a-tooltip>
            SKU ID<template slot="title">SKU ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.skuId"  :placeholder="$t('请输入')+'SKU ID'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            用户ID<template slot="title">用户ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('请输入')+'用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="orderNo" >
        <span slot="label" >
          <a-tooltip>
            订单编号<template slot="title">订单编号</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderNo" :maxLength="64" :placeholder="$t('请输入')+'订单编号'" />
      </a-form-model-item>
      <a-form-model-item prop="goodsName" >
        <span slot="label" >
          <a-tooltip>
            商品名称<template slot="title">商品名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsName" :maxLength="255" :placeholder="$t('请输入')+'商品名称'" />
      </a-form-model-item>
      <a-form-model-item prop="userNick" >
        <span slot="label" >
          <a-tooltip>
            用户昵称<template slot="title">用户昵称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userNick" :maxLength="100" :placeholder="$t('请输入')+'用户昵称'" />
      </a-form-model-item>
      <a-form-model-item prop="content" >
        <span slot="label" >
          <a-tooltip>
            评价内容<template slot="title">评价内容</template>
          </a-tooltip>
        </span>
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item prop="star" >
        <span slot="label" >
          <a-tooltip>
            星级 1-5<template slot="title">星级 1-5</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.star"  :placeholder="$t('请输入')+'星级 1-5'" />
      </a-form-model-item>
      <a-form-model-item prop="grade" >
        <span slot="label" >
          <a-tooltip>
            评价等级：1好评 2中评 3差评<template slot="title">评价等级：1好评 2中评 3差评</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.grade"  :placeholder="$t('请输入')+'评价等级：1好评 2中评 3差评'" />
      </a-form-model-item>
      <a-form-model-item prop="imagesJson" >
        <span slot="label" >
          <a-tooltip>
            评价图片JSON数组字符串，例如：['url1','url2']<template slot="title">评价图片JSON数组字符串，例如：['url1','url2']</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.imagesJson" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="isAnonymous" >
        <span slot="label" >
          <a-tooltip>
            是否匿名 1是 0否<template slot="title">是否匿名 1是 0否</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isAnonymous"  :placeholder="$t('请输入')+'是否匿名 1是 0否'" />
      </a-form-model-item>
      <a-form-model-item prop="replyContent" >
        <span slot="label" >
          <a-tooltip>
            平台回复内容<template slot="title">平台回复内容</template>
          </a-tooltip>
        </span>
        <editor v-model="form.replyContent" />
      </a-form-model-item>
      <a-form-model-item prop="isReplied" >
        <span slot="label" >
          <a-tooltip>
            是否已回复 1是 0否<template slot="title">是否已回复 1是 0否</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isReplied"  :placeholder="$t('请输入')+'是否已回复 1是 0否'" />
      </a-form-model-item>
      <a-form-model-item prop="repliedAt" >
        <span slot="label" >
          <a-tooltip>
            平台回复时间<template slot="title">平台回复时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.repliedAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="isTop" >
        <span slot="label" >
          <a-tooltip>
            是否置顶 1是 0否<template slot="title">是否置顶 1是 0否</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isTop"  :placeholder="$t('请输入')+'是否置顶 1是 0否'" />
      </a-form-model-item>
      <a-form-model-item prop="sort" >
        <span slot="label" >
          <a-tooltip>
            排序<template slot="title">排序</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.sort"  :placeholder="$t('请输入')+'排序'" />
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            状态 1启用 0禁用<template slot="title">状态 1启用 0禁用</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getReview, addReview, updateReview } from '@/api/order/review'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        orderId: null,

        orderItemId: null,

        goodsId: null,

        skuId: null,

        userId: null,

        orderNo: null,

        goodsName: null,

        userNick: null,

        content: null,

        star: null,

        grade: null,

        imagesJson: null,

        isAnonymous: null,

        replyContent: null,

        isReplied: null,

        repliedAt: null,

        isTop: null,

        sort: null,

        status: 0,

        createTime: null,
        localeFieldMap:{},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        orderId: [
          { required: true, message: '订单ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        orderItemId: [
          { required: true, message: '订单明细ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        goodsId: [
          { required: true, message: '商品ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        skuId: [
          { required: true, message: 'SKU ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        orderNo: [
          { required: true, message: '订单编号'+this.$t('不能为空'), trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: '商品名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userNick: [
          { required: true, message: '用户昵称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: '评价内容'+this.$t('不能为空'), trigger: 'blur' }
        ],
        star: [
          { required: true, message: '星级 1-5'+this.$t('不能为空'), trigger: 'blur' }
        ],
        grade: [
          { required: true, message: '评价等级：1好评 2中评 3差评'+this.$t('不能为空'), trigger: 'blur' }
        ],
        isAnonymous: [
          { required: true, message: '是否匿名 1是 0否'+this.$t('不能为空'), trigger: 'blur' }
        ],
        replyContent: [
          { required: true, message: '平台回复内容'+this.$t('不能为空'), trigger: 'blur' }
        ],
        isReplied: [
          { required: true, message: '是否已回复 1是 0否'+this.$t('不能为空'), trigger: 'blur' }
        ],
        isTop: [
          { required: true, message: '是否置顶 1是 0否'+this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序'+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 1启用 0禁用'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        orderId: null,
        orderItemId: null,
        goodsId: null,
        skuId: null,
        userId: null,
        orderNo: null,
        goodsName: null,
        userNick: null,
        content: null,
        star: null,
        grade: null,
        imagesJson: null,
        isAnonymous: null,
        replyContent: null,
        isReplied: null,
        repliedAt: null,
        isTop: null,
        sort: null,
        status: 0,
        createTime: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReview({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateReview(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addReview(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
